const CLASS_COLOR_MAP = [
	{ className: 'wholesale-open', color: '#610d1a' },
	{ className: 'mobile-menu-open', color: '#7495b1' },
	{ className: 'contact-open', color: '#7495b1' },
	{ className: 'custom-enquiry-open', color: '#7495b1' },
	{ className: 'newsletter-open', color: '#7495b1' },
	{ className: 'search-open', color: '#c7c7c5' },
	{ className: 'login-open', color: '#c7c7c5' },
]

const DEFAULT_COLOR = '#c7c7c5'

export default class ThemeColor {
	constructor() {
		this.meta = document.querySelector('meta[name="theme-color"]')
		if (!this.meta) return

		this.currentColor = this.meta.getAttribute('content')
		this.observer = new MutationObserver(() => this.update())
		this.observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })
	}

	update() {
		const match = CLASS_COLOR_MAP.find((entry) => document.body.classList.contains(entry.className))
		const color = match ? match.color : DEFAULT_COLOR

		if (this.currentColor === color) return
		this.currentColor = color

		// Safari diffs theme-color values and only repaints when it detects a change.
		// Setting an intermediate color with alpha (fe) forces a repaint cycle.
		this.meta.setAttribute('content', color + 'fe')
		requestAnimationFrame(() => {
			this.meta.setAttribute('content', color)
		})
	}
}
